import React from "react";

import classes from "./style.module.scss";

const NoLogoUploaded = () => {
    return (
        <div className={classes.noLogoContainer}>
            <p className={classes.noLogoText}>No logo uploaded</p>
        </div>
    );
};

export default NoLogoUploaded;
